module.exports = __webpack_public_path__ + "static/logo-90f9af6c008d86601728e9bcf1966298.png";